import React from 'react';
import {Toast, Icon} from 'antd-mobile';
import postData from '../../assets/xhr';
import model from '../../assets/model';

class FileItem extends React.PureComponent{
    constructor(props){
        super(props);
        this.state = {
            upload: 0
        }
    }
    componentWillMount(){
        this.xhr = this.uploadFile();
    }
    uploadFile(){
        let props = this.props;
        let file = props.file;

        if (file.uploading > 0){
            return;
        }
        // 上传图片
        let formData = new FormData();
        formData.append('fileData', file);
        formData.append('cardId', model.cardId);
        file.uploading = 1;  // 上传中
        this.setState({
            upload: 1
        })
        props.upload && props.upload(props.index, file);
        let xhr = postData({
            url: '/smartform/rest/extApi/data/file/upload',
            data: formData,
            form: true,
            callback: (res)=>{
                let {code, message, data} = res;
                if (code === 0){
                    file.uploading = 2; // 上传成功
                    file.tempPath = data.filePath;
                    this.setState({
                        upload: 2
                    })
                }else{
                    Toast.info(message, 1.5);
                    file.uploading = 3; //上传失败
                    this.setState({
                        upload: 3
                    })
                }
            },
            error: () => {
                Toast.info($st('上传失败'), 1.5);
                file.uploading = 3; //上传失败
                this.setState({
                    upload: 3
                })
            }
        });
        return xhr;
    }
    getFileSize(size){
        let key = 'B', value = size;
        if (value > 1024){
            key='K';
            value = value/1024;
        }
        if (value > 1024){
            key = 'M';
            value = value/1024;
        }
        value = Math.floor(value*100)/100;
        return `${value}${key}`;
    }
    onDelete =()=>{
        let onDelete = this.props.delete;
        onDelete && onDelete();
        // 取消上传
        let xhr = this.xhr;
        xhr && xhr.abort();
    }
    onReload= ()=>{
        let file = this.props.file;
        file.uploading = 0;
        this.setState({
            upload: 0
        });
        this.uploadFile();
    }
    componentWillUnmount(){
        let xhr = this.xhr;
        xhr && xhr.abort();
    }
    render(){

        let props = this.props;
        let file = props.file;
        let state = this.state;

        return (
            <div className="file-item">
                <span className="fileName">{file.name}</span>
                {state.upload === 2 && <span className="fileSize">{this.getFileSize(file.size)}</span>}
                {state.upload === 1 && <span className="fileSize fileIcon"><Icon type='loading'></Icon></span>}
                {state.upload === 3 && <span className='fileSize fileReload' onClick={this.onReload}>{$st("重传")}</span>}
                <span className="btn-del" onClick={this.onDelete}>
                    <Icon type="cross" size="sm"></Icon>
                </span>

            </div>
        )
    }
}
export default FileItem;



// WEBPACK FOOTER //
// ./src/component/FileAttachment/FileItem.js